/**
 * Formats a phone number string to the display format: +880-1XXX-XXX-XXX
 * It uses the actual digits but inserts hyphens at the specified positions.
 * * @param {string} number The original phone number string (e.g., "+8801713157012").
 * @returns {string} The formatted phone number string for display (e.g., "+880-1713-157-012").
 */
const formatPhoneNumberForDisplay = (number) => {
    // 1. Clean up the number by removing ALL non-digit characters except '+'
    const cleanedDigits = number.replace(/[()\s-]/g, '');

    // 2. Apply the custom formatting (assuming a Bangladeshi format starting with +8801)
    // Target format: [CC+Prefix 5 chars] - [4 digits] - [3 digits] - [4 digits]
    // Example Indexing: +8801 7131 570 12 (14 characters total)

    // Extracting parts based on the example structure
    const part1 = cleanedDigits.substring(0, 4);  // e.g., +880
    const part2 = cleanedDigits.substring(4, 8);  // e.g., 1713
    const part3 = cleanedDigits.substring(8, 11); // e.g., 157
    const part4 = cleanedDigits.substring(11);    // e.g., 012

    // Only join the parts that exist to handle shorter numbers gracefully
    const parts = [part1, part2, part3, part4].filter(p => p.length > 0);

    return parts.join('-');
};

// --- Main React Component ---

const PhoneNumberDisplay = ({ numbersString }) => {
    // Ensure the input is treated as a string, defaulting to an empty string if null/undefined
    const safeNumbersString = String(numbersString || '');

    const numbersArray = safeNumbersString
        .split(',')
        .map(number => number.trim())
        .filter(number => number.length > 0);

    if (numbersArray.length === 0) {
        return null;
    }

    return (
        <div>
            {numbersArray.map((number, index) => (
                <a
                    key={index}
                    // The href uses the original, uncleaned number (which usually works fine for tel:)
                    // or you could use a cleaned version: `href={'tel:' + number.replace(/[^+\d]/g, '')}`
                    href={`tel:${number}`}
                    style={{ marginRight: '15px', display: 'block' }}
                >
                    {/* Use the formatted version for display */}
                    {formatPhoneNumberForDisplay(number)}
                </a>
            ))}
        </div>
    );
};

export default PhoneNumberDisplay;
